import formatters from './formatters.js';

var format = {

	/**
	 * Initialiseer de formatter
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		target.addEventListener('change', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('input[data-format]')) {
					format.proces(event.target);
					break;
				}
			}
		}, false);

	},

	/**
	 * Verwerk formatting
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	proces: function(target) {
		let formatter = target.getAttribute('data-format') || null;
		if ((formatter !== null) && (typeof formatter == 'string')) {
			let valueFormatted = formatters[formatter](target.value);
			target.value = valueFormatted;
		}
	}

};

export default format;
